import { env } from './EnvironmentConfig';

export const APP_NAME = process.env.REACT_APP_SITE_NAME;
export const API_BASE_URL = env.API_ENDPOINT_URL;
export const API_REFETCH_TIME = env.REFETCH_TIME;
export const API_AUCTION_REFETCH_TIME = env.AUCTION_REFETCH_TIME;
export const APP_PREFIX_PATH = '';
export const APP_IN_PRODUCTION = process.env.NODE_ENV === 'production';
export const GOOGLE_MAP_API_KEY = "AIzaSyBucHHSLvAcbRq3CWGkRzzdYo7Da8hIzCQ";
export const LIVE_VENDOR_SITE = 'https://vendor.eventoq.in/'
export const TEST_VENDOR_SITE = 'https://weddingvendor.riolabz.com/'
